import Paper from '@mui/material/Paper'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import { connectionsPanelLoadingSx } from './ConnectionsLayout'

export function WidgetConnectionsLoading() {
  return (
    <Paper sx={connectionsPanelLoadingSx}>
      <CircularProgress sx={{  color: '#333333' }} />
      <Typography sx={{ mt: 2 }} color="text.main">
        Loading widget…
      </Typography>
    </Paper>
  )
}
